import PublisherSiteButton from '../../../../common/components/documentViewer/publisherSiteButton';
import { IOrderViewerMainStore } from '../../typing/stores';
import { inject } from 'mobx-react';

export default inject((stores: IOrderViewerMainStore) => ({
	publisherSite: stores.orderViewerStore.viewModel.headerModel.publisherSite
}))(PublisherSiteButton);
